import { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Nav, Table, Badge, Spinner } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "../../common/Utils";
import { UserContext } from "../../common";
import DropdownMenu from "./DropdownMenu";
import DocViewer from "./DocViewer";
import CqcContent from "./CqcContent";
import md5 from "md5";
import ChoosePlans from '../../components/application/ChoosePlans';

const CqcDashboard = (props) => {
  const { userData } = useContext(UserContext);
  const [data, setData] = useState(false);
  const [braUsers, setBraUsers] = useState(false);
  const [viewDoc, setViewDoc] = useState(false);
  const [contentready, setContentReady] = useState(false);
  const [udocs, setUDocs] = useState({
    doctypes: [],
    userdocs: [],
    userdocfiles: [],
    counts: [],
    bars: [],
  });
  const [loading, setLoading] = useState(true);
  const [dtype, setDType] = useState(1);
  const [SDate, setSDate] = useState(false);
  const [resources, setResources] = useState(false);
  const [ctype, setCType] = useState('content');
  const [udContent, setUDContent] = useState(false);
  const [upload, setUpload] = useState(false);
  const [trail, setTrail] = useState(false);
  const [assigned, setAssigned] = useState(false);
  const [assignedSearch, setAssignedSearch] = useState("");
  const [assUserTemp, setAssUserTemp] = useState([]);
  const [assigning, setAssigning] = useState(false);
  const [cal, setCal] = useState(false);
  const [loadres, setLoadres] = useState(false);
  const [showprof, setShowprof] = useState(true);
  const [cqcNote, showCQCNote] = useState(false);
  const [notes, setNotes] = useState([]);
  const [saveNote, setSaveNote] = useState(false);
  const [filter, setFilter] = useState({
    pp: 100,
    year: '',
    status: 0,
    st: 0,
    txt: "",
  });

  useEffect(() => {
    setContentReady(false);
    setUDContent(false);
  },[upload]);

  useEffect(() => {
    setAssignedSearch("");
    setAssUserTemp([]);
  }, [assigned]);

  const printContent = (title,content,print) => {
    const printWindow = window.open('', '', `fullscreen=yes`);
    printWindow.document.write('<html><head><title>' + title + '</title>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(content);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    if(print){
      printWindow.print();
    }
  };

  const fetchCQCNotes = () => {
    if (cqcNote !== false && _.isUndefined(cqcNote.loading)) {
      showCQCNote({ ...cqcNote, loading: true });
      axios
        .get(Utils.apiUrl(`cqcs/fetchnotes/${cqcNote.id}`), Utils.apiHeaders())
        .then((res) => {
          showCQCNote({ ...cqcNote, loading: false });
          if (res.data.success) {
            setNotes(res.data.data);
          } else {
            window.alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(fetchCQCNotes, [cqcNote]);

  const saveCQCNote = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    const formData = new FormData(frm);
    if (_.isEmpty(frm.note.value)) {
      window.alert("Please fill notes to save");
      return false;
    }
    formData.append("cqcdoc_id", cqcNote.id);
    setSaveNote(true);
    axios
      .post(Utils.apiUrl(`cqcs/savenote`), formData, Utils.apiHeaders())
      .then((res) => {
        setSaveNote(false);
        showCQCNote(_.omit(cqcNote, ["notes", "loading"]));
      })
      .catch((err) => console.log(err));
  };

  const deleteNote = (nid) => {
    if (window.confirm("You are going to delete this note, continue?")) {
      setNotes(_.filter(notes, (n) => n.id !== nid));
      axios.delete(Utils.apiUrl(`cqcs/delnote/${nid}`), Utils.apiHeaders()).catch((err) => console.log(err));
    }
  };

  let cnt = 0;
  const years = [];
  const currentYear = new Date().getFullYear();
  const range = 20; // Change this value to adjust the range of selectable years
  for (let i = 2020; i <= currentYear + range; i++) {
    years.push(i);
  }

  const changestatus = (id, status) => {
    axios
      .get(Utils.apiUrl(`cqcs/changecqcstatus/${id}/${status}/${new moment().format("YYYY-MM-DD HH:mm:ss")}`), Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        if (res.data.success) {
          setUDocs((prevUdocs) => {
            return {
              ...prevUdocs,
              userdocs: prevUdocs.userdocs.map((userdoc) => {
                if (userdoc.id === id) {
                  // Update the userdocfile with the matching ID
                  return { ...userdoc, ...res.data.udf[0] };
                }
                return userdoc;
              }),
            };
          });
          //console.log(udocs);
          // window.alert(res.data.message);
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const setYearValue = (e) => {
    setFilter({
      ...filter,
      st: 0,
      year: parseInt(e.currentTarget.value),
      status: 0,
    });
    setDType(0);
    // fetchCategory(e.currentTarget.value);
  };
  let stout = null;
  const setSearchTxt = (e) => {
    let txt = e.currentTarget.value;
    if (stout != null) {
      window.clearTimeout(stout);
    }
    stout = window.setTimeout(() => {
      setFilter({ ...filter, st: 0, txt: txt });
      setDType(0);
    }, 1000);
  };

  const addFilters = (start) => {
    let str = _.compact(_.map(filter, (fv, fk) => (fv !== "" ? `${fk}=${fv}` : undefined)));
    str.push(`st=${start}`);
    str.push(`profile=${data === false}`);
    str.push(`braUsers=${braUsers === false}`);
    return "?" + str.join("&");
  };

  const profileDetails = (start = 0) => {
    setLoading(true);
    // status===0 ? setShowprof(true) : setShowprof(false);
    axios
      .get(Utils.apiUrl("cqcs/fetchprofile") + addFilters(start), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          if (_.get(res, "data.profile.id", false)) {
            setData(res.data.profile);
          }
          if (_.get(res, "data.braUsers", false)) {
            setBraUsers(res.data.braUsers);
          }

          setUDocs({
            doctypes: _.get(res, "data.doctypes", []),
            userdocs: _.get(res, "data.userdocs", []),
            userdocfiles: _.get(res, "data.userdocfiles", []),
            counts: _.get(res, "data.counts", []),
            bars: _.get(res, "data.bars[0]", []),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(profileDetails, [filter]);

  const uploadFile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    let formData = new FormData(frm);
    formData.append("time", new moment().format("YYYY-MM-DD HH:mm:ss"));

    //== if selected year is previous year, then expiry date can be blank, else not allowed
    if (frm.exp_date.value === "" && parseInt(frm.year.value) !== (parseInt(new moment().format("YYYY"))-1)) {
      window.alert("Please select expiry date of the uploading document!");
      return false;
      //new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split("T")[0];
    }else{
      if(parseInt(new moment(frm.exp_date.value).format("YYYYMMDD")) < parseInt(new moment().format("YYYYMMDD"))){
        window.alert("Please select expiry date of today or later!");
        return false;
      }
    }

    /*if (frm.exp_date.value != "") {
      if (parseInt(frm.year.value) > parseInt(new moment(frm.exp_date.value).format("YYYY"))) {
        window.alert(`Please select an expiry date of ${frm.year.value} or later!`);
        return false;
      }
    }*/

    setLoadres(parseInt(frm.udid.value));

    axios
      .post(Utils.apiUrl("cqcs/uploadudf"), formData, Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        if (res.data.success) {
          if (filter.status == 2 || filter.status == 3 || filter.status == 4) {
            setUpload(false);
          }
          setUDocs({
            ...udocs,
            userdocfiles: [...udocs.userdocfiles, res.data.udf],
          });

          if (frm.year.value !== filter.year) {
            window.alert(`Document has been uploaded for the ${frm.year.value} you can view it by changing the year in filter option!`);
          }

          frm.reset();

          profileDetails();
          // window.alert(res.data.message);
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const deleteudf = (udf) => {
    if (window.confirm(`You are going to delete upload file ${udf.udoc}, continue?`)) {
      setLoadres(parseInt(udf.udid));
      axios
        .delete(Utils.apiUrl("cqcs/deleteudf/") + udf.id, Utils.apiHeaders())
        .then((res) => {
          setLoadres(false);
          if (res.data.success) {
            let tmp = [...udocs.userdocfiles];
            _.remove(tmp, (udf1) => parseInt(udf1.id) === parseInt(udf.id));
            setUDocs({ ...udocs, userdocfiles: tmp });
            profileDetails();
            // window.alert(res.data.message);
          } else {
            window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const getColor = (doc) => {
    const filteredData = udocs.userdocfiles.filter((item) => item.udid === doc.id);
    if (filteredData.length === 0) {
      return "#070d59";
    }
    // Filter data with max id to get last uploaded doc data
    let lastDoc = filteredData.find((item) => item.expire_on==='0000-00-00');
    if(_.get(lastDoc,'length',0) == 0) {
      lastDoc = _.maxBy(filteredData,(item)=> item.expire_on);
    }
    
    //const lastDoc = filteredData.filter((item) => parseInt(item.id) === maxId)[0];
    // console.log(lastDoc);

    // const lastDoc = filteredData[filteredData.length - 1];
    if (lastDoc && lastDoc.exp_status == "1") {
      return "#ec5353";
    }
    if (lastDoc && lastDoc.exp_soon_status == "1") {
      return "#FFBF00";
    }
    // if (filteredData.some(doc => (doc.doc_status == '2' && doc.exp_status == '0' ))) {
    //   return '#FFBF00';
    // }
    return "green";
  };

  const renderDocTypes = () => {
    return (
      <div className="mt-0">
        <Row>
          <Col sm="12" className="mt-2 mb-4 alert alert-info">
            <Alert className="p-1 ps-0 ms-0">
              <b>For Best Practice we recommend completing the documents marked as Mandatory and Highly Recommended</b>
            </Alert>
            <Row>
              <Col sm="12">
                <div
                  className={`badge  text-yellow`}
                  style={{
                    backgroundColor: "#ff3c00",
                  }}
                >
                  {/* {Utils.addZero((cnt += 1))} */}
                  {udocs.userdocs.filter((item) => parseInt(item.required) === 1).length}
                </div>{" "}
                Mandatory
              </Col>
              <Col sm="12">
                <div
                  className={`badge  text-yellow`}
                  style={{
                    backgroundColor: "#800080",
                  }}
                >
                  {/* {Utils.addZero((cnt += 1))} */}
                  {udocs.userdocs.filter((item) => parseInt(item.required) === 2).length}
                </div>{" "}
                Highly Recommended
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col sm="3" className="float-start">
            <select
              className="form-select "
              title={udocs.doctypes[dtype]}
              style={{
                backgroundColor: "#03A9F4",
                color: "white",
                maxWidth: "400px",
              }}
              required
              value={dtype}
              onChange={(e) => {
                setDType(e.target.value);
                setSDate(0);
              }}
            >
              <option style={{ backgroundColor: "white", color: "black" }} value={0}>
                {"Category"}
              </option>
              {_.map(udocs.doctypes, (cat, catidx) => (
                <option title={cat} style={{ backgroundColor: "white", color: "black" }} value={catidx}>
                  {cat}
                </option>
              ))}
            </select>
          </Col>
          {
            <Col sm="9">
              <Nav variant="pills" className="px-2 float-end" defaultActiveKey={SDate} onSelect={setSDate}>
                {[
                  {
                    color: "#76D773",
                    date:
                      udocs.userdocs.filter(
                        (item) =>
                          item.gap_status == 1 &&
                          (dtype == 0 || dtype == item.cat) &&
                          (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length +
                      "/" +
                      udocs.userdocs.filter(
                        (item) => (dtype == 0 || dtype == item.cat) && (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length,
                    idx: 1,
                    title: "Have This Count",
                  },
                  {
                    color: "#FFBF00",
                    date:
                      udocs.userdocs.filter(
                        (item) =>
                          item.gap_status == 2 &&
                          (dtype == 0 || dtype == item.cat) &&
                          (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length +
                      "/" +
                      udocs.userdocs.filter(
                        (item) => (dtype == 0 || dtype == item.cat) && (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length,
                    idx: 2,
                    title: "Working on it Count",
                  },
                  {
                    color: "#EC5353",
                    date:
                      udocs.userdocs.filter(
                        (item) =>
                          item.gap_status == 3 &&
                          (dtype == 0 || dtype == item.cat) &&
                          (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length +
                      "/" +
                      udocs.userdocs.filter(
                        (item) => (dtype == 0 || dtype == item.cat) && (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length,
                    idx: 3,
                    title: "Dont Have Count",
                  },
                  {
                    color: "#848484",
                    date:
                      udocs.userdocs.filter(
                        (item) =>
                          item.gap_status == 4 &&
                          (dtype == 0 || dtype == item.cat) &&
                          (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length +
                      "/" +
                      udocs.userdocs.filter(
                        (item) => (dtype == 0 || dtype == item.cat) && (filter.status == 0 || filter.status == 5 || getColor(item) != "#070d59")
                      ).length,
                    idx: 4,
                    title: "NA Count",
                  },
                ].map((t, index) => (
                  <Nav.Item className="me-0 ">
                    <Nav.Link className="rounded-0" title={t.title} style={{ backgroundColor: t.color, color: "white" }} key={index} eventKey={t.idx}>
                      {t.date}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
          }
        </Row>
        {/*  */}

        <Card style={{ backgroundColor: "#CEDDEF88" }}>
          <Card.Body className="m-2">
            <Table responsive={true}>
              <thead>
                <tr>
                  <th className="text-end" width="50">
                    ##
                  </th>
                  <th>DOCUMENT</th>
                  <th>RESOURCES</th>
                  <th>STATUS</th>
                  <th>AUDIT</th>
                  <th>ASSIGNED</th>
                  <th>GAP ANALYSIS</th>
                  <th>
                    <img src={`${process.env.PUBLIC_URL}/images/notes-d.png`} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {_.map(
                  _.filter(udocs.userdocs, (p) => (dtype == 0 || parseInt(p.cat) === parseInt(dtype)) && (!SDate || SDate == p.gap_status)),
                  (doc, idx) => {
                    let res = JSON.parse(doc.resources);
                    res.contents = contentOfUDoc(doc);
                    return (
                      (filter.status == 0 || filter.status == 5 || getColor(doc) != "#070d59") && (
                        <tr>
                          <td className="text-end">
                            <div
                              className={`badge  text-yellow`}
                              style={{
                                backgroundColor: doc.required == 2 ? "#800080" : doc.required == 1 ? "#ff3c00" : "#0d6efd",
                              }}
                            >
                              {Utils.addZero((cnt += 1))}
                            </div>
                          </td>
                          <td>{dtype != 0 ? doc.title : doc.title + " (" + doc.cat_name + ")"}</td>
                          <td>
                            <Button type="button" variant="primary" onClick={() => setResources(res)} disabled={res.length === 0}>
                              View
                            </Button>
                          </td>
                          {/* <td>
                          {loadres === parseInt(doc.id) && <ProgressBar variant="success" animated now={100} className="mt-2" />}
                          {loadres !== parseInt(doc.id) && udfForm(doc.id)}
                        </td> */}
                          <td>
                            <Button
                              className="me-2 ms2"
                              type="button"
                              variant="contained"
                              style={{
                                backgroundColor: getColor(doc),
                                color: "white",
                              }}
                              onClick={() => setUpload(doc.id)}
                            >
                              {getColor(doc) == "#070d59" ? "Complete" : "Manage"}
                            </Button>
                          </td>
                          <td>
                            <Button
                              className="me-2 ms2 "
                              type="button"
                              variant="primary"
                              onClick={() => setTrail(doc.id)}
                              disabled={res.length === 0}
                            >
                              Trail
                            </Button>
                          </td>

                          <td>
                            {assigning === doc.id && (
                              <>
                                <Spinner animation="grow" variant="dark" /> Assigning..
                              </>
                            )}
                            {assigning !== doc.id && (
                              <Button
                                className="me-2 ms2 "
                                type="button"
                                variant="light"
                                onClick={() => setAssigned(doc.id)}
                                disabled={res.length === 0}
                              >
                                Assigned - {doc.assignedUsers ? doc.assignedUsers.split(",").length : 0}
                              </Button>
                            )}
                          </td>

                          <td>
                            <DropdownMenu key={doc.id} doc={doc} changestatus={changestatus} dtype={dtype} />
                          </td>
                          <td>
                            <img
                              src={`${process.env.PUBLIC_URL}/images/notes.png`}
                              className="clickable"
                              title={`Notes for ${doc.title}`}
                              onClick={() => showCQCNote(doc)}
                            />
                          </td>
                        </tr>
                      )
                    );
                  }
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    );
  };

  const showResources = () => {
    return (
      <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setResources(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Resources</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {_.get(resources.files, "length", 0) > 0 &&<h3>Documents</h3>} */}
          <ol>
            {/* {_.map(resources.files, (r) => (
              <li key={r} className="py-1">
                <div className=""></div>
                <a href={Utils.apiUrl("users/downloadud") + "/" + r}>
                  {r}
                  <span className="float-end me-4"> <img className="me-2" src='images/download.png' /></span>
                </a>
                
              </li>
            ))} */}
            {_.map(resources.contents, (content) => {
              return <li key={content.id} className="py-1 ">
                <div className=" mb-1">
                  {content.title}
                  <img className="float-end mx-2 pb-1" src='images/download-d.png' />
                    {/*<a className="float-end" title="Download Content" target="_blank" href={Utils.apiUrl("cqcs/downloadcontent") + "/" + md5(userData.uid)+ "?cid=" + md5(content.id)}>
                      <img className="mx-2" src='images/download.png' />
                    </a>*/}
                    <span className="float-end clickable" title="View Content" style={{width: '20px'}}  onClick={() => setUDContent({...content,mode:'view',show:true})}>
                      {Utils.viewIcon()}
                    </span>
                    
                  {/*</a>*/}
                </div>
              </li>
            })}
            {_.map(resources.files, (r) => (
              <li key={r} className="py-1 ">
                <div className=" mb-1 ">
                  <a className="float-end clickable"  href={Utils.apiUrl("cqcs/downloadud") + "/" + r}>
                    <img className="mx-2" src='images/download.png' />
                  </a>
                  {/*<a target="_blank" href={`${process.env.PUBLIC_URL}/cqc/docviewer/${r}`}>*/}
                    {r}
                    <span className="float-end" style={{width: '20px'}} onClick={() => setViewDoc(r)}>
                      {Utils.viewIcon()}
                    </span>
                  {/*</a>*/}
                </div>
              </li>
            ))}
            {_.map(resources.links, (r) => (
              <li key={r} className="py-1 ">
                <div className=" mb-1">
                  <a href={r} target="_blank" className="">
                    {r}
                    <span className="float-end me-4">🔗 </span>
                  </a>
                </div>
              </li>
            ))}
          </ol>
          {/* {_.get(resources.links, "length", 0) > 0 &&<h3>Links</h3>} */}
          {/* <ol>
            
          </ol> */}
        </Modal.Body>
      </Modal>
    );
  };

  const showViewDoc = () => {
    return (
      <Modal show={true} fullscreen={true} dialogClassName="modal-fullscreen" onHide={() => setViewDoc(false)}>
        <Modal.Header closeButton>Resource: {viewDoc}</Modal.Header>
        <Modal.Body><DocViewer doc={viewDoc} /></Modal.Body>
      </Modal>);
  };

  const showUDContent = () => {

    return (
      <Modal show={true} size="fullscreen" onHide={() => setUDContent({...udContent, show:false})}>
        <Modal.Header closeButton>Content: {udContent.title}</Modal.Header>
        <Modal.Body><CqcContent {...udContent} onChange={(cont) => setUDContent({...udContent,content: cont})} /></Modal.Body>
        {udContent.mode==='edit' && <Modal.Footer><Button type="button" variant="primary" size="sm" onClick={() => {
          setContentReady(udContent.content);
          setUDContent({...udContent,show:false});
        }}>Save Content</Button></Modal.Footer>}
      </Modal>);
  };

  const contentOfUDoc = (ud) => {
    if(ud.contents){
      return ud.contents.split('^|^').map(udc => {
        udc = udc.split('^^');
        return {id:udc[0],title: udc[1]}
      });
    }else{
      return [];
    }
  };

  const showUpload = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(upload));
    let ud = _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(upload));
    let settings = JSON.parse(ud[0].settings);
    

    // let expired = moment().isAfter(udf[0].updated_at, "year");

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setUpload(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"> {ud[0].title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}

          <Table responsive={true}>
            <thead>
              <tr>
                <td>Document Name</td>
                {/* <td>Status</td> */}
                <td>Uploaded By</td>
                <td>Uploaded On</td>
                <td>Upload Year</td>

                <td>Expire On</td>
                <td colspan="3">Actions</td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>{r.udoc}</td>
                  <td>{r.uploader_name}</td>
                  {/* <td>{showStatus(r)}</td> */}
                  <td>{r.created_at}</td>
                  <td>{r.year}</td>
                  <td>{r.expire_on === "0000-00-00" ? "No Expiry date" : r.expire_on}</td>
                  <td>
                    {r.ftype==='file' && <div className="clickable" style={{minWidth: "20px"}} onClick={() => setViewDoc(Utils.viewerLink(r.udoc, `cqcs/downloadudf/${r.furl}`))}>
                      {Utils.viewIcon()}
                    </div>}
                    {r.ftype==='content' && <div className="clickable" style={{minWidth : "20px"}} onClick={() => printContent(r.udoc, r.content, false)} >
                      {Utils.viewIcon()}
                    </div>}
                  </td>
                  <td>
                    {/* <a href={Utils.apiUrl("cqcs/downloadudf") + "/" + r.furl}> */}
                    {r.ftype==='file' && <a target="_blank" href={Utils.viewerLink(r.udoc, `cqcs/downloadudf/${r.furl}`)}>
                      <img src="images/download.png" />
                    </a>}
                    {r.ftype==='content' && <div className="clickable" style={{minWidth : "20px"}} onClick={() => printContent(r.udoc, r.content, true)}>
                      {Utils.printIcon()}
                    </div>}
                  </td>
                  <td>
                    <Button variant="danger" className="p-1 clickable" size="xs" title="Delete file" onClick={() => deleteudf(r)}>
                      X
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Nav variant="tabs" defaultActiveKey={ctype} onSelect={setCType}>
            <Nav.Item>
              <Nav.Link eventKey="content">Add Content</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="file">Upload File</Nav.Link>
            </Nav.Item>
          </Nav>
          <Form onSubmit={uploadFile}>
            <input type="hidden" name="udid" value={upload} />
            <div className="row mt-2 d-flex align-items-end">
              <div className="col-md-3">
                {ctype==='file' && <input type="file" required name="udoc" />}
                {ctype==='content' && <select className="form-select" name="cqcdoc_id" defaultValue={parseInt(_.get(udContent,'id',0))} required onChange={(e) => {
                  if(e.target.value!==""){
                    setUDContent({id: parseInt(e.target.value),title: e.target.selectedOptions[0].getAttribute('title'),show: false});
                  }else{
                    setUDContent(false);
                  }
                }}>
                  <option value="">Select Template</option>
                  {_.map(contentOfUDoc(ud[0]), c => <option key={c.id} value={c.id} title={c.title}>{c.title}</option>)}
                </select>}
              </div>
              <div className="col-md-2">
                {ctype==='content' && _.get(udContent,'id',0) > 0 && <button type="button" className="btn btn-sm btn-info" onClick={() => setUDContent({...udContent,mode:'edit',show:true})}>Update Content</button>}
              </div>
              {(ctype==='file' || contentready!==false) && <>
                <input type="hidden" name="cqcdoc_id" value={udContent.id} />
                <input type="hidden" name="title" value={udContent.title} />
                <textarea className="d-none" name="content">{contentready}</textarea>
                <div className="col-md-2">
                  Year
                  <select className="form-select " name="year" required defaultValue={new Date().getFullYear()}>
                    {years.map((y) => (
                      <option value={y}>{y}</option>
                    ))}
                  </select>
                </div>
                {settings.flag == 3 && (
                  <div className="col-md-2">
                    Expire Date
                    <input
                      type="date"
                      name="exp_date"
                      maxlength="255"
                      className="form-control"
                      format="dd/mm/yyyy"
                      onKeyDown={(e) => e.preventDefault()}
                      placeholder="Expire Date"
                    />
                  </div>
                )}

                <div className="col-md-3">
                  <Button variant="primary" type="submit">
                    Upload
                  </Button>
                </div>
              </>}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  const showTrail = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(trail));
    // let ud =  _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(upload));

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setTrail(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Document Trail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}
          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Uploaded By</td>
                <td>Upload On</td>
                <td>Upload Year</td>
                <td>Expires On</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>{r.udoc}</td>
                  <td>{r.uploader_name}</td>

                  <td>{r.updated_at}</td>
                  <td>{r.year}</td>
                  <td>{r.expire_on}</td>
                  {/* <td>{showStatus(r)}</td> */}
                  <td>
                    {/* <a href={Utils.apiUrl("users/downloadudf") + "/" + r.furl}> */}
                    <a target="_blank" href={Utils.viewerLink(r.udoc, `cqcs/downloadudf/${r.furl}`)}>
                      <img src="images/download.png" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const assignToUser = () => {
    const cdid = assigned;
    let data = `cqcdoc_id=${cdid}&users=${assUserTemp.join(",")}`;
    setAssigning(cdid);
    setAssigned(false);
    return axios.post(Utils.apiUrl("cqcs/assignToUsers"), data, Utils.apiHeaders()).then((res) => {
      if (res.data.success) {
        let tmpuserdocs = udocs.userdocs.filter((ud) => parseInt(ud.id) !== parseInt(cdid));
        let tmp2userdocs = udocs.userdocs.filter((ud) => parseInt(ud.id) === parseInt(cdid))[0];
        let assignedUsers = res.data.data + (tmp2userdocs.assignedUsers !='' ? ',' : '') + tmp2userdocs.assignedUsers; //== if already assigned users, then add a comma
        tmpuserdocs = [...tmpuserdocs, { ...tmp2userdocs, assignedUsers: assignedUsers }]; //== update the assigned users
        //tmpuserdocs = [...tmpuserdocs, { ...tmp2userdocs, assignedUsers: res.data.data }];
        setUDocs({ ...udocs, userdocs: tmpuserdocs });
        setAssigning(false);
      }
    });
  };

  const showAssigned = () => {
    let udoc = _.filter(udocs.userdocs, (ud) => parseInt(ud.id) === parseInt(assigned))[0]; //== user document we are talking about
    let assUsers = udoc.assignedUsers ? braUsers.filter((ou) => udoc.assignedUsers.split(",").includes(ou.id)) : []; //== only those which are already assigned
    assUsers = [...assUsers, ...braUsers.filter((ou) => assUserTemp.includes(ou.id))]; //== filter those which are selected recently
    assUsers = _.sortBy(assUsers, ["name", "designation"]);

    let orgAssUsers = _.sortBy(
      braUsers.filter(
        (u) =>
          (u.name.toLowerCase().includes(assignedSearch.toLowerCase()) || u.designation.toLowerCase().includes(assignedSearch.toLowerCase())) &&
          assUsers.filter((au) => au.id === u.id).length === 0
      ),
      ["name", "designation"]
    ); //== those which are neither assigned nor selected

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setAssigned(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{udoc.title}: Assign Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {assUsers.length > 0 && (
            <Alert variant="info">
              <b>Assigned to users: </b>
              <br />
              {_.map(assUsers, (ou) => (
                <Badge className="bg-light text-dark p-2 py-1 mt-1 me-1" style={{ lineHeight: "20px" }}>
                  {ou.name}
                  {assUserTemp.includes(ou.id) && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="p-1 py-0 ms-2"
                      onClick={() => setAssUserTemp(_.without(assUserTemp, ou.id))}
                    >
                      <b>X</b>
                    </Button>
                  )}
                </Badge>
              ))}
              {assUserTemp.length > 0 && (
                <div className="text-end">
                  <hr />
                  <Button variant="success" onClick={assignToUser}>
                    Assign to Users - {assUserTemp.length}
                  </Button>
                </div>
              )}
            </Alert>
          )}

          <input type="text" className="form-control" placeholder="Search user" onChange={(e) => setAssignedSearch(e.currentTarget.value)} />

          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Designation</td>
                <td width="50">Add</td>
              </tr>
            </thead>
            <tbody>
              {_.map(orgAssUsers, (ou) => (
                <tr>
                  <td>{ou.name}</td>
                  <td>{ou.designation}</td>
                  <td>
                    <Button variant="success" size="sm" onClick={() => setAssUserTemp([...assUserTemp, ou.id])}>
                      Add
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const showNotesForCQC = () => {
    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => showCQCNote(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Notes - {cqcNote.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {saveNote === true && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Saving CQC Note..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {saveNote === false && (
            <>
              <Form onSubmit={saveCQCNote}>
                <div className="d-flex">
                  <textarea name="note" required className="form-control me-2" rows={2} placeholder="Enter your Note"></textarea>
                  <div className="ms-2">
                    <Button type="submit" variant="dark">
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            </>
          )}
          {cqcNote.loading === true && (
            <Alert variant="warning" className="p-3">
              <p className="loading-msg">Fetching CQC Note..</p>
              <ProgressBar variant="warning" animated now={100} />
            </Alert>
          )}
          {cqcNote.loading === false && (
            <div style={{ maxHeight: "400px", overflow: "auto" }}>
              {_.get(notes, "length", 0) === 0 && (
                <Alert variant="danger" className="p-3">
                  <p className="loading-msg">No comments found!</p>
                </Alert>
              )}
              {_.map(notes, (note) => (
                <div key={note.id} className="d-flex mt-1 py-2 border-bottom">
                  <div>
                    <div className="badge bg-light text-dark">{Utils.toLocal(note.created_at).format("HH:mm MMM DD, YY")}</div>
                  </div>
                  <div className="text-start text-dark flex-grow-1">{note.note}</div>
                  {note.user_id === userData.uid && (
                    <div className="text-end">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/delete.png`}
                        className="clickable text-danger me-1"
                        title={`Delete this note!`}
                        onClick={() => deleteNote(note.id)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  const docSummery = () => {
    const numStyle = {
      minWidth: "50px",
      height: "50px",
      color: "white",
      textAlign: "center",
      padding: "10px 10px 10px 10px",
      borderRadius: "8px",
      marginTop: "8px",
    };
    return (
      <Row>
        <Col>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body>
              <Row>
                <Col xs="6" sm="6" md="6" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Documents"
                    onClick={() => {
                      setFilter({ ...filter, st: 0, status: 0 });
                      setDType(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div className="title me-2 d-flex justify-content-center align-items-center">
                        <span style={{ ...numStyle, backgroundColor: "#070d59" }}>{!loading && _.get(udocs,'counts[0].total_count',0)}</span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Total</span>{" "}
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all in Date Documents"
                    onClick={() => {
                      setFilter({ ...filter, st: 0, status: 2 });
                      setDType(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div className="title me-2 d-flex justify-content-center align-items-center">
                        <span style={{ ...numStyle, backgroundColor: "green" }}>{!loading && _.get(udocs,'counts[0].in_count',0)}</span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">In Date</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3" mt="5">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Expire Soon Documents"
                    onClick={() => {
                      setFilter({ ...filter, st: 0, status: 3 });
                      setDType(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div className="title me-2 d-flex justify-content-center align-items-center">
                        <span style={{ ...numStyle, backgroundColor: "#ffbf00 " }}>{!loading && _.get(udocs,'counts[0].expire_soon_count',0)}</span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Expiring Soon</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Expired Documents"
                    onClick={() => {
                      setFilter({ ...filter, st: 0, status: 4 });
                      setDType(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div className="title me-2 d-flex justify-content-center align-items-center">
                        <span style={{ ...numStyle, backgroundColor: "#ec5353 " }}>{!loading && _.get(udocs,'counts[0].expire_count',0)}</span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Expired</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Not Applicable Documents"
                    onClick={() => {
                      setFilter({ ...filter, st: 0, status: 5 });
                      setDType(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div className="title me-2 d-flex justify-content-center align-items-center">
                        <span style={{ ...numStyle, backgroundColor: "#848484 " }}>{!loading && udocs.bars.na_count}</span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Not Applicable</span>
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  if (!_.get(userData, "is_cqc", false)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <div className="mt-4">
      <h2 className="my-3">
        <b>CQC Profile</b>
      </h2>
      {viewDoc !== false && showViewDoc()}
      {_.get(udContent,'show',false) !== false && showUDContent()}
      {docSummery()}

      <Row>
        <Col>
          {/* <h3 className="my-3 title"> </h3> */}
          <Form>
            <Row className="gx-1 mt-4">
              {/* <Col className="d-none d-sm-block">
                    <Button variant="light" className="style1 w-100 radius-left shadow-cst h-100">
                        <img src={`${process.env.PUBLIC_URL}/images/filter.png`} className="me-3" alt="Filter" /> Filter
                    </Button>
                    </Col> */}
              <Col xs={10} className="bg-light">
                <Row className="gx-1">
                  <Col xs={3}>
                    <select className="form-control form-control-select form-select shadow-cst" onChange={setYearValue} value={filter.year}>
                      <option value={""}>YEAR</option>

                      {years.map((y) => (
                        <option value={y}>{y}</option>
                      ))}
                      {/* {cats.map((c) => (
                            <option key={c.id} value={c.id}>
                                {c.name}
                            </option>
                            ))} */}
                    </select>
                  </Col>
                  <Col xs={9}>
                    <input
                      type="text"
                      className="form-control form-control-select form-select shadow-cst"
                      placeholder="Search by Title"
                      onKeyUp={setSearchTxt}
                      // defaultValue={filter.txt}
                      // value={}
                    />
                  </Col>
                </Row>
                {/* <Row>
                        <Col xs={12} className="mt-1">
                        
                        </Col>
                    </Row> */}
              </Col>
              <Col>
                <Button
                  type="reset"
                  variant="light"
                  className="style1 w-100 radius-right shadow-cst h-100"
                  onClick={() => {
                    setFilter({
                      ...filter,
                      st: 0,
                      year: 0,
                      status: 0,
                      txt: "",
                    });
                    setSDate(false);
                    setDType(1);
                  }}
                >
                  Clear filter
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <Card border="light" className="shadow mt-5 dashboardStats">
        <Card.Body className="mx-3">
          {/* {showprof&&<div><h4 className="mb-3">
            <b>Personal Details</b>
          </h4>
          <Card style={{ backgroundColor: "#CEDDEF88" }}>
            <Card.Body className="m-2">{renderForm()}</Card.Body>
          </Card></div>} */}

          {loading && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Fetching details..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {!loading && renderDocTypes()}
          <div>
            {/* <span className="mt-4" style={{ color: "red" }}>
              Note : Documents numbered in Orange are Mandatory.
              <br />
              Documents numbered in Purple are Highly Recommended.
            </span> */}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "5px",
                marginBottom: "5px",
              }}
            >
              <a href={Utils.apiUrl("cqcs/exportdata") + "/" + _.get(data, "id", "") + addFilters(0) + "&cat=" + dtype + "&gap=" + SDate}>
                <Button type="submit" variant="primary" className="  shadow-cst p-0 text-light p-2 px-5">
                  Export Data
                </Button>
              </a>
            </div>
          </div>
        </Card.Body>
      </Card>

      {(_.get(resources.files, "length", 0) > 0 || _.get(resources.links, "length", 0) > 0) && showResources()}
      {upload && showUpload()}
      {trail && showTrail()}
      {assigned && showAssigned()}
      {cqcNote !== false && showNotesForCQC()}
          
    </div>
  );
};

export default CqcDashboard;
